import React from 'react';
import { TrendingUpIcon, UsersIcon, MessageCircleIcon, CheckCircleIcon, ArrowUpRightIcon, ArrowDownRightIcon, ClockIcon, ThumbsUpIcon } from 'lucide-react';
export function WhatsAppAnalytics() {
  return <div className="space-y-6 max-w-7xl mx-auto" data-id="element-1017">
      {/* Top Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-1018">
        <StatCard title="Total Conversations" value="2,845" change="+15.2%" trend="up" icon={<MessageCircleIcon className="text-blue-600" size={24} data-id="element-1020" />} bg="bg-blue-50" data-id="element-1019" />
        <StatCard title="Avg Response Time" value="4m 12s" change="-1.5m" trend="up" icon={<ClockIcon className="text-green-600" size={24} data-id="element-1022" />} bg="bg-green-50" data-id="element-1021" />
        <StatCard title="Lead Conversion Rate" value="24.8%" change="+3.2%" trend="up" icon={<TrendingUpIcon className="text-purple-600" size={24} data-id="element-1024" />} bg="bg-purple-50" data-id="element-1023" />
        <StatCard title="Customer Satisfaction" value="4.8/5" change="+0.2" trend="up" icon={<ThumbsUpIcon className="text-orange-600" size={24} data-id="element-1026" />} bg="bg-orange-50" data-id="element-1025" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1027">
        {/* Main Chart Area */}
        <div className="lg:col-span-2 bg-white p-6 rounded-xl border border-gray-200 shadow-sm" data-id="element-1028">
          <div className="flex justify-between items-center mb-6" data-id="element-1029">
            <div data-id="element-1030">
              <h3 className="font-semibold text-gray-900" data-id="element-1031">
                Channel Performance
              </h3>
              <p className="text-sm text-gray-500" data-id="element-1032">
                Message volume across channels
              </p>
            </div>
            <select className="text-sm border-gray-300 rounded-lg text-gray-600 focus:ring-blue-500 focus:border-blue-500" data-id="element-1033">
              <option data-id="element-1034">Last 30 Days</option>
              <option data-id="element-1035">This Quarter</option>
              <option data-id="element-1036">This Year</option>
            </select>
          </div>

          {/* Chart Visualization */}
          <div className="h-72 flex items-end justify-between space-x-4 px-4 pt-8" data-id="element-1037">
            {[{
            day: 'Mon',
            wa: 65,
            sms: 20,
            voice: 15
          }, {
            day: 'Tue',
            wa: 75,
            sms: 25,
            voice: 10
          }, {
            day: 'Wed',
            wa: 55,
            sms: 30,
            voice: 20
          }, {
            day: 'Thu',
            wa: 85,
            sms: 15,
            voice: 25
          }, {
            day: 'Fri',
            wa: 90,
            sms: 20,
            voice: 15
          }, {
            day: 'Sat',
            wa: 45,
            sms: 10,
            voice: 5
          }, {
            day: 'Sun',
            wa: 30,
            sms: 5,
            voice: 5
          }].map((data, i) => <div key={i} className="flex flex-col items-center flex-1 group h-full justify-end" data-id="element-1038">
                <div className="w-full flex flex-col-reverse space-y-1 space-y-reverse h-full justify-end" data-id="element-1039">
                  <div className="w-full bg-green-500 rounded-t-sm opacity-90 hover:opacity-100 transition-opacity relative group" style={{
                height: `${data.wa}%`
              }} data-id="element-1040">
                    <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white text-xs py-1 px-2 rounded opacity-0 group-hover:opacity-100 transition-opacity z-10 whitespace-nowrap" data-id="element-1041">
                      WA: {data.wa}
                    </div>
                  </div>
                  <div className="w-full bg-purple-500 opacity-90 hover:opacity-100 transition-opacity" style={{
                height: `${data.sms}%`
              }} data-id="element-1042"></div>
                  <div className="w-full bg-blue-500 rounded-b-sm opacity-90 hover:opacity-100 transition-opacity" style={{
                height: `${data.voice}%`
              }} data-id="element-1043"></div>
                </div>
                <span className="text-xs text-gray-500 mt-3 font-medium" data-id="element-1044">
                  {data.day}
                </span>
              </div>)}
          </div>
          <div className="flex justify-center space-x-6 mt-6" data-id="element-1045">
            <div className="flex items-center text-xs text-gray-600" data-id="element-1046">
              <div className="w-3 h-3 bg-green-500 rounded-full mr-2" data-id="element-1047"></div>{' '}
              WhatsApp
            </div>
            <div className="flex items-center text-xs text-gray-600" data-id="element-1048">
              <div className="w-3 h-3 bg-purple-500 rounded-full mr-2" data-id="element-1049"></div>{' '}
              SMS
            </div>
            <div className="flex items-center text-xs text-gray-600" data-id="element-1050">
              <div className="w-3 h-3 bg-blue-500 rounded-full mr-2" data-id="element-1051"></div>{' '}
              Voice
            </div>
          </div>
        </div>

        {/* AI Insights Panel */}
        <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm" data-id="element-1052">
          <h3 className="font-semibold text-gray-900 mb-4" data-id="element-1053">
            AI Strategic Insights
          </h3>
          <div className="space-y-4" data-id="element-1054">
            <InsightItem type="positive" text="WhatsApp leads convert 3x faster than SMS leads. Consider shifting SMS budget to WhatsApp API." data-id="element-1055" />
            <InsightItem type="warning" text="High drop-off rate (45%) detected after 'Price Quote' stage. Review pricing templates." data-id="element-1056" />
            <InsightItem type="neutral" text="Peak engagement hours shifted to 6-8 PM. Adjust auto-responder timing." data-id="element-1057" />

            <div className="pt-6 border-t border-gray-100 mt-6" data-id="element-1058">
              <h4 className="text-sm font-medium text-gray-700 mb-4" data-id="element-1059">
                Lead Sentiment Distribution
              </h4>
              <div className="space-y-3" data-id="element-1060">
                <SentimentBar label="Positive" value={68} color="bg-green-500" count="1,240" data-id="element-1061" />
                <SentimentBar label="Neutral" value={22} color="bg-gray-400" count="412" data-id="element-1062" />
                <SentimentBar label="Negative" value={10} color="bg-red-500" count="185" data-id="element-1063" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Dealer Performance Table */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-1064">
        <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center" data-id="element-1065">
          <h3 className="font-semibold text-gray-900" data-id="element-1066">
            Dealer Performance Leaderboard
          </h3>
          <button className="text-sm text-blue-600 font-medium hover:underline" data-id="element-1067">
            View Full Report
          </button>
        </div>
        <table className="w-full" data-id="element-1068">
          <thead className="bg-gray-50 text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1069">
            <tr data-id="element-1070">
              <th className="px-6 py-3 text-left" data-id="element-1071">Dealer Name</th>
              <th className="px-6 py-3 text-left" data-id="element-1072">Total Leads</th>
              <th className="px-6 py-3 text-left" data-id="element-1073">Response Time</th>
              <th className="px-6 py-3 text-left" data-id="element-1074">Conversion Rate</th>
              <th className="px-6 py-3 text-left" data-id="element-1075">Performance</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200" data-id="element-1076">
            {[{
            name: 'Mumbai Motors',
            leads: 450,
            time: '2m 30s',
            rate: '32%',
            score: 95
          }, {
            name: 'Delhi Auto Hub',
            leads: 380,
            time: '5m 15s',
            rate: '28%',
            score: 88
          }, {
            name: 'Bangalore Cars',
            leads: 310,
            time: '8m 45s',
            rate: '24%',
            score: 82
          }, {
            name: 'Pune Premium',
            leads: 245,
            time: '12m 10s',
            rate: '18%',
            score: 75
          }, {
            name: 'Chennai Wheels',
            leads: 190,
            time: '15m 20s',
            rate: '15%',
            score: 68
          }].map((dealer, i) => <tr key={i} className="hover:bg-gray-50 transition-colors" data-id="element-1077">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-1078">
                  <div className="flex items-center" data-id="element-1079">
                    <div className="h-8 w-8 rounded-full bg-gray-100 flex items-center justify-center text-gray-600 font-bold mr-3 text-xs" data-id="element-1080">
                      {dealer.name.substring(0, 2).toUpperCase()}
                    </div>
                    <span className="font-medium text-gray-900" data-id="element-1081">
                      {dealer.name}
                    </span>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-gray-600 font-medium" data-id="element-1082">
                  {dealer.leads}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-gray-600" data-id="element-1083">
                  {dealer.time}
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-1084">
                  <span className="text-green-600 font-bold" data-id="element-1085">
                    {dealer.rate}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-1086">
                  <div className="flex items-center" data-id="element-1087">
                    <div className="w-24 bg-gray-200 rounded-full h-2 mr-2" data-id="element-1088">
                      <div className={`h-2 rounded-full ${dealer.score > 90 ? 'bg-green-500' : dealer.score > 75 ? 'bg-blue-500' : 'bg-yellow-500'}`} style={{
                    width: `${dealer.score}%`
                  }} data-id="element-1089"></div>
                    </div>
                    <span className="text-xs font-medium text-gray-500" data-id="element-1090">
                      {dealer.score}/100
                    </span>
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}
function StatCard({
  title,
  value,
  change,
  trend,
  icon,
  bg
}: any) {
  return <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-1091">
      <div className="flex justify-between items-start mb-4" data-id="element-1092">
        <div className={`p-3 rounded-lg ${bg}`} data-id="element-1093">{icon}</div>
        <div className={`flex items-center text-sm font-medium ${trend === 'up' ? 'text-green-600' : 'text-red-600'}`} data-id="element-1094">
          {trend === 'up' ? <ArrowUpRightIcon size={16} className="mr-1" data-id="element-1095" /> : <ArrowDownRightIcon size={16} className="mr-1" data-id="element-1096" />}
          {change}
        </div>
      </div>
      <h4 className="text-gray-500 text-sm font-medium mb-1" data-id="element-1097">{title}</h4>
      <p className="text-2xl font-bold text-gray-900" data-id="element-1098">{value}</p>
    </div>;
}
function InsightItem({
  type,
  text
}: {
  type: 'positive' | 'warning' | 'neutral';
  text: string;
}) {
  const colors = {
    positive: 'bg-green-50 text-green-700 border-green-100',
    warning: 'bg-orange-50 text-orange-700 border-orange-100',
    neutral: 'bg-blue-50 text-blue-700 border-blue-100'
  };
  return <div className={`p-4 rounded-lg border text-sm leading-relaxed ${colors[type]}`} data-id="element-1099">
      {text}
    </div>;
}
function SentimentBar({
  label,
  value,
  color,
  count
}: {
  label: string;
  value: number;
  color: string;
  count: string;
}) {
  return <div className="flex items-center text-xs" data-id="element-1100">
      <span className="w-16 text-gray-500 font-medium" data-id="element-1101">{label}</span>
      <div className="flex-1 h-2.5 bg-gray-100 rounded-full overflow-hidden mx-3" data-id="element-1102">
        <div className={`h-full ${color}`} style={{
        width: `${value}%`
      }} data-id="element-1103"></div>
      </div>
      <div className="w-16 text-right" data-id="element-1104">
        <span className="font-bold text-gray-700 block" data-id="element-1105">{value}%</span>
        <span className="text-[10px] text-gray-400 block" data-id="element-1106">{count}</span>
      </div>
    </div>;
}